import { createSlice } from '@reduxjs/toolkit';

const clientchatSlice = createSlice({
  name: 'chat',
  initialState: {
    messages: [],
  },
  reducers: {
    setMessages(state, action) {
      state.messages = action.payload;
    },
    addMessages(state, action) {
      state.messages = [...action.payload, ...state.messages];
    },
    addNewMessage(state, action) {
      state.messages.push(action.payload);
    },
  },
});

export const { setMessages, addMessages, addNewMessage } = clientchatSlice.actions;
export default clientchatSlice.reducer;